module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function (fox, $, undefined) {
	'use strict';

	fox.registerWidget('CustomDatepicker', {
		configure: function () {
			this.selectedDate = null; //apply Date object

			this.registerOptions('', {
				initialDate: null,
				autoRender: true,
				template: 'component_custom_datepicker',
				handleDom: {
					showDp: {
						event: 'click',
						target: ['.date-choicer', '#date-choicer', '#date-choicer .drop-arrow'],
						callback: 'showDp'
					},
					cancelDate: {
						event: 'click',
						target: '#cancel-date',
						callback: 'hideDp'
					},
					applyDate: {
						event: 'click',
						target: '#apply-date',
						callback: 'applyDate'
					},
					hideOnOutsideClick: {
						event: 'click',
						target: document.body,
						eventChecker: fox.bind(function (e) {
							if (!this.getParent())
								return false;

							return this.$dpw && !$(e.target).hasClass('date-choicer') &&
								!$(e.target).hasClass('mc-form-field') &&
								!$(e.target).hasClass('drop-arrow') &&
								!this.$dpw.is(e.target) &&
								this.$dpw.has(e.target).length === 0;
						}, this),
						callback: 'hideDp'
					},
					selectOnChange: {
						event: 'change',
						target: '.gui-c-select select',
						callback: 'selectOnChange'
					},
					clear: {
						target: '.clear',
						callback: 'reset'
					}
				}
			});
		
			this.callParent('configure', arguments);
		},

		init: function () {
			if (this.getOption('newSelect')) {
				this.embedWidget('selectContainer', 'Widget', {
					'embed.container': '.datepicker-header',
					autoRender: true,
					template: 'div#month+div#year'
				});

				['month', 'year'].forEach(function (name) {
					var options = {
						embed: {
							widget: '@parent #selectContainer',
							container: '#' + name
						}
					};

					if (name === 'month') options.months = true;
					if (name === 'year') {
						options.yearsLimit = this.getOption('yearsLimit') || [2013, new Date().getFullYear() + 1];
					}

					this.embedWidget(name, 'Control_Select', options);
				}, this);

				this.handleEvent('.Control_Select', 'change', function (value) {
					var data = {};

					this.wom('.Control_Select').forEach(function (select) {
						data[select.getAlias() === 'year' ? 'y' : 'm'] = select.getValue();
					});

					this.onChangeMonthYear(data.y, data.m);
					this.dispatchEvent('on_year_month_change', data);
				}.bind(this));
			}

			this.resetDatepickerLeftPosHaldler = this.resetDatepickerLeftPos.bind(this);
			
			this.callParent('init', arguments);
		},

		deactivate: function () {
			if (this.getOption('autoPosition') !== false) {
				window.removeEventListener('resize', this.resetDatepickerLeftPosHaldler);
			}

			this.callParent('deactivate', arguments);
		},

		showDp: function () {
			if (this.getOption('disabled')) {
				return;
			}
			var othersDp = fox.wom.select('~.CustomDatepicker');

			if (othersDp.length) {
				fox.each(othersDp, function (w) {
					w.hideDp();
				});
			}

			this.$dpw.show();
			this.dp.find('select').wrap('<div class="gui-c-select"></div>');

			 if (this.getOption('autoPosition') !== false) {
				this.correctPosition();
				window.addEventListener('resize', this.resetDatepickerLeftPosHaldler);
			}
		},

		rendering: function () {
			var yearsRange,
				yearsLimit = this.getOption('yearsLimit');
			if (yearsLimit) {
				yearsRange = fox.utils.getRange(yearsLimit[0], yearsLimit[1] + 1);
			} else {
				yearsRange = fox.utils.getRange(2013, new Date().getFullYear() + 1);
			}

			if (this.getOption('yearsLimitReverse')) {
				yearsRange.reverse();
			}
			
			this.setTemplateOptions('yearsRange', yearsRange);
			
			this.callParent('rendering', arguments);
		},

		embedToDom: function () {
			this.prepareDatepicker();

			return this.callParent('embedToDom', arguments);
		},

		prepareDatepicker: function () {
			this.$dpw = $(this.dom1('.date-picker-window'));
			this.$dpw.hide();
			
			this.dp = $(document.createElement('span')).insertAfter(this.$dpw.find('.datepicker-header'));

			this.dp.datepicker(fox.merge({
				dayNamesMin: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
				dateFormat: 'mm/dd/yy',
				defaultDate: this.selectedDate ? this.selectedDate : this.getOption('initialDate'),
				monthNamesShort: fox.utils.getMonthsArray(),
				onChangeMonthYear: fox.bind(this.onChangeMonthYear, this)
			}, this.getOption('dpOptions') || {}));

			if (this.getOption('initialDate') === null && this.getOption('emptyPlaceholder')) {
				this.dp.datepicker('setDate', null);
			}

			this._setSelectedDate(this.selectedDate || this.dp.datepicker('getDate'))
				.visualUpdate()
				.setDateOnView();
		},

		onChangeMonthYear: function (y, m, e) {
			this.dp.datepicker('setDate', [m, 1, y].join('/'));
		},

		selectOnChange: function (el, a, scope, e) {
			var $el = $(e.target);
			var v = this.getSelectValues(scope);

			$el.prev().text($el.find('option:selected').text());

			this.onChangeMonthYear(v.y, v.m);
			this.dispatchEvent('on_year_month_change', v);
		},

		getSelectValues: function (scope) {
			var values = {};

			fox.each(scope.dom('.gui-c-select select'), function (el) {
				values[el.value.length === 4 ? 'y' : 'm'] = el.value;
			});

			return values;
		},

		setDateOnView: function () {
			var 
				$m = $(this.dom1('.datepicker-month')),
				$y = $(this.dom1('.datepicker-year')),
				date = (this.selectedDate || (this.getOption('highlightDate') ? this.getOption('highlightDate') : new Date())),
				emptyStr = this.getOption('emptyPlaceholder'),
				placeholderStr = fox.utils.dateFormat('%d %b %Y', date);

			if (!this.selectedDate && emptyStr) {
				placeholderStr = emptyStr;
			}

			this.insertIntoPlaceholder(placeholderStr);

			if (this.getOption('newSelect')) {
				var m = date.getMonth() + 1;
				var y = date.getFullYear();

				this.rwom1('#month').setValue(m > 9 ? m : '0' + m, true);
				this.rwom1('#year').setValue(y, true);

				return this;
			}

			$m
				.val(date.getMonth() + 1)
				.find(['option[value="', date.getMonth() + 1, '"]'].join(''))
				.prop('selected', true)
				.parent().prev()
				.text($m.find('option:selected').text());

			$y
				.val(date.getFullYear())
				.find(['option[value="', date.getFullYear(), '"]'].join(''))
				.prop('selected', true)
				.parent().prev()
				.text($y.find('option:selected').text());

			return this;
		},

		insertIntoPlaceholder: function(str) {
			$(this.dom1('.date-choicer')).text(str);
		},

		hideDp: function () {
			if (this.$dpw) this.$dpw.hide();
			this.datepickerLeftPos = undefined;

			if (this.getOption('autoPosition') !== false) {
				window.removeEventListener('resize', this.resetDatepickerLeftPosHaldler);
			}

			return this;
		},

		applyDate: function () {
			this._setSelectedDate(this.dp.datepicker('getDate'))
				.visualUpdate()
				.setDateOnView()
				.hideDp()
				.dispatchEvent('selectDate');

			return this;
		},

		_setSelectedDate: function (val) {
			this.selectedDate = (val === null ? val : new Date(val));

			return this;
		},

		visualUpdate: function() {
			if (!this.getOption('newSelect')) {
				return this;
			}

			if (!this.selectedDate) {
				$(this.dom1('.datepicker.dropdown')).addClass('default');

				return this;
			}

			$(this.dom1('.datepicker.dropdown')).removeClass('default');
			return this;
		},

		reset: function() {
			this.dp.datepicker('setDate', this.getOption('initialDate'));
			this.applyDate();
		},

		resetDatepickerLeftPos: function() {
			if (this.resizeTimer !== undefined) {
				clearTimeout(this.resizeTimer);
				delete this.resizeTimer;
			}

			this.resizeTimer = setTimeout(function() {
				delete this.datepickerLeftPos;

				if (this.$dpw.is(':visible')) {
					this.correctPosition();
				}
			}.bind(this), 500);
		},

		correctPosition: function() {
			if (this.datepickerLeftPos !== undefined) {
				return;
			}

			var viewPort = $(window).width(),
				$parent = $(this.element),
				parentWidth = $parent.outerWidth(),
				dpWidth = this.$dpw.outerWidth(),
				parentLeft = $parent.offset().left;

			this.datepickerLeftPos = (dpWidth - parentWidth) / 2;
			
			if ((parentLeft - this.datepickerLeftPos) < 0) {
				this.datepickerLeftPos = parentLeft;
			} else if ((parentLeft + parentWidth + this.datepickerLeftPos) > viewPort) {
				this.datepickerLeftPos =  parentLeft + parentWidth + 2*this.datepickerLeftPos - viewPort;
			}
			this.$dpw.css('left', -this.datepickerLeftPos + 'px');
		}

	}, 'Widget');

})(fox, fox.jQuery);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/widget/customDatepicker.js
// module id = 304
// module chunks = 2